module.exports = __webpack_public_path__ + "static/media/settings-plus.2a88d589.svg";